/**
 * Países para o seletor de DDI do telefone.
 *
 * Gerado a partir de countries.constant.js (códigos ISO + DDI) com os nomes em pt-BR.
 * Brasil vem primeiro por ser o caso dominante; o restante segue ordem alfabética.
 * `ddi` são apenas os dígitos, no mesmo formato da coluna `telephone_ddi` do banco.
 */

export const DEFAULT_DDI = '55';

export const phoneCountries = [
  { iso: 'BR', ddi: '55', name: 'Brasil', flag: '🇧🇷' },
  { iso: 'AF', ddi: '93', name: 'Afeganistão', flag: '🇦🇫' },
  { iso: 'ZA', ddi: '27', name: 'África do Sul', flag: '🇿🇦' },
  { iso: 'AL', ddi: '355', name: 'Albânia', flag: '🇦🇱' },
  { iso: 'DE', ddi: '49', name: 'Alemanha', flag: '🇩🇪' },
  { iso: 'AD', ddi: '376', name: 'Andorra', flag: '🇦🇩' },
  { iso: 'AO', ddi: '244', name: 'Angola', flag: '🇦🇴' },
  { iso: 'AI', ddi: '1264', name: 'Anguila', flag: '🇦🇮' },
  { iso: 'AQ', ddi: '672', name: 'Antártida', flag: '🇦🇶' },
  { iso: 'AG', ddi: '1268', name: 'Antígua e Barbuda', flag: '🇦🇬' },
  { iso: 'SA', ddi: '966', name: 'Arábia Saudita', flag: '🇸🇦' },
  { iso: 'DZ', ddi: '213', name: 'Argélia', flag: '🇩🇿' },
  { iso: 'AR', ddi: '54', name: 'Argentina', flag: '🇦🇷' },
  { iso: 'AM', ddi: '374', name: 'Armênia', flag: '🇦🇲' },
  { iso: 'AW', ddi: '297', name: 'Aruba', flag: '🇦🇼' },
  { iso: 'AU', ddi: '61', name: 'Austrália', flag: '🇦🇺' },
  { iso: 'AT', ddi: '43', name: 'Áustria', flag: '🇦🇹' },
  { iso: 'AZ', ddi: '994', name: 'Azerbaijão', flag: '🇦🇿' },
  { iso: 'BS', ddi: '1242', name: 'Bahamas', flag: '🇧🇸' },
  { iso: 'BD', ddi: '880', name: 'Bangladesh', flag: '🇧🇩' },
  { iso: 'BB', ddi: '1246', name: 'Barbados', flag: '🇧🇧' },
  { iso: 'BH', ddi: '973', name: 'Barein', flag: '🇧🇭' },
  { iso: 'BE', ddi: '32', name: 'Bélgica', flag: '🇧🇪' },
  { iso: 'BZ', ddi: '501', name: 'Belize', flag: '🇧🇿' },
  { iso: 'BJ', ddi: '229', name: 'Benin', flag: '🇧🇯' },
  { iso: 'BM', ddi: '1441', name: 'Bermudas', flag: '🇧🇲' },
  { iso: 'BY', ddi: '375', name: 'Bielorrússia', flag: '🇧🇾' },
  { iso: 'BO', ddi: '591', name: 'Bolívia', flag: '🇧🇴' },
  { iso: 'BA', ddi: '387', name: 'Bósnia e Herzegovina', flag: '🇧🇦' },
  { iso: 'BW', ddi: '267', name: 'Botsuana', flag: '🇧🇼' },
  { iso: 'BN', ddi: '673', name: 'Brunei', flag: '🇧🇳' },
  { iso: 'BG', ddi: '359', name: 'Bulgária', flag: '🇧🇬' },
  { iso: 'BF', ddi: '226', name: 'Burquina Faso', flag: '🇧🇫' },
  { iso: 'BI', ddi: '257', name: 'Burundi', flag: '🇧🇮' },
  { iso: 'BT', ddi: '975', name: 'Butão', flag: '🇧🇹' },
  { iso: 'CV', ddi: '238', name: 'Cabo Verde', flag: '🇨🇻' },
  { iso: 'CM', ddi: '237', name: 'Camarões', flag: '🇨🇲' },
  { iso: 'KH', ddi: '855', name: 'Camboja', flag: '🇰🇭' },
  { iso: 'CA', ddi: '1', name: 'Canadá', flag: '🇨🇦' },
  { iso: 'QA', ddi: '974', name: 'Catar', flag: '🇶🇦' },
  { iso: 'KZ', ddi: '77', name: 'Cazaquistão', flag: '🇰🇿' },
  { iso: 'TD', ddi: '235', name: 'Chade', flag: '🇹🇩' },
  { iso: 'CL', ddi: '56', name: 'Chile', flag: '🇨🇱' },
  { iso: 'CN', ddi: '86', name: 'China', flag: '🇨🇳' },
  { iso: 'CY', ddi: '357', name: 'Chipre', flag: '🇨🇾' },
  { iso: 'VA', ddi: '379', name: 'Cidade do Vaticano', flag: '🇻🇦' },
  { iso: 'CO', ddi: '57', name: 'Colômbia', flag: '🇨🇴' },
  { iso: 'KM', ddi: '269', name: 'Comores', flag: '🇰🇲' },
  { iso: 'CD', ddi: '243', name: 'Congo - Kinshasa', flag: '🇨🇩' },
  { iso: 'KR', ddi: '82', name: 'Coreia do Sul', flag: '🇰🇷' },
  { iso: 'CR', ddi: '506', name: 'Costa Rica', flag: '🇨🇷' },
  { iso: 'HR', ddi: '385', name: 'Croácia', flag: '🇭🇷' },
  { iso: 'CU', ddi: '53', name: 'Cuba', flag: '🇨🇺' },
  { iso: 'AN', ddi: '599', name: 'Curaçao', flag: '🇦🇳' },
  { iso: 'DK', ddi: '45', name: 'Dinamarca', flag: '🇩🇰' },
  { iso: 'DJ', ddi: '253', name: 'Djibuti', flag: '🇩🇯' },
  { iso: 'DM', ddi: '1767', name: 'Dominica', flag: '🇩🇲' },
  { iso: 'EG', ddi: '20', name: 'Egito', flag: '🇪🇬' },
  { iso: 'SV', ddi: '503', name: 'El Salvador', flag: '🇸🇻' },
  { iso: 'AE', ddi: '971', name: 'Emirados Árabes Unidos', flag: '🇦🇪' },
  { iso: 'EC', ddi: '593', name: 'Equador', flag: '🇪🇨' },
  { iso: 'ER', ddi: '291', name: 'Eritreia', flag: '🇪🇷' },
  { iso: 'SK', ddi: '421', name: 'Eslováquia', flag: '🇸🇰' },
  { iso: 'SI', ddi: '386', name: 'Eslovênia', flag: '🇸🇮' },
  { iso: 'ES', ddi: '34', name: 'Espanha', flag: '🇪🇸' },
  { iso: 'SZ', ddi: '268', name: 'Essuatíni', flag: '🇸🇿' },
  { iso: 'US', ddi: '1', name: 'Estados Unidos', flag: '🇺🇸' },
  { iso: 'EE', ddi: '372', name: 'Estônia', flag: '🇪🇪' },
  { iso: 'ET', ddi: '251', name: 'Etiópia', flag: '🇪🇹' },
  { iso: 'FJ', ddi: '679', name: 'Fiji', flag: '🇫🇯' },
  { iso: 'PH', ddi: '63', name: 'Filipinas', flag: '🇵🇭' },
  { iso: 'FI', ddi: '358', name: 'Finlândia', flag: '🇫🇮' },
  { iso: 'FR', ddi: '33', name: 'França', flag: '🇫🇷' },
  { iso: 'GA', ddi: '241', name: 'Gabão', flag: '🇬🇦' },
  { iso: 'GM', ddi: '220', name: 'Gâmbia', flag: '🇬🇲' },
  { iso: 'GH', ddi: '233', name: 'Gana', flag: '🇬🇭' },
  { iso: 'GE', ddi: '995', name: 'Geórgia', flag: '🇬🇪' },
  { iso: 'GI', ddi: '350', name: 'Gibraltar', flag: '🇬🇮' },
  { iso: 'GD', ddi: '1473', name: 'Granada', flag: '🇬🇩' },
  { iso: 'GR', ddi: '30', name: 'Grécia', flag: '🇬🇷' },
  { iso: 'GL', ddi: '299', name: 'Groenlândia', flag: '🇬🇱' },
  { iso: 'GP', ddi: '590', name: 'Guadalupe', flag: '🇬🇵' },
  { iso: 'GU', ddi: '1671', name: 'Guam', flag: '🇬🇺' },
  { iso: 'GT', ddi: '502', name: 'Guatemala', flag: '🇬🇹' },
  { iso: 'GG', ddi: '44', name: 'Guernsey', flag: '🇬🇬' },
  { iso: 'GY', ddi: '595', name: 'Guiana', flag: '🇬🇾' },
  { iso: 'GF', ddi: '594', name: 'Guiana Francesa', flag: '🇬🇫' },
  { iso: 'GN', ddi: '224', name: 'Guiné', flag: '🇬🇳' },
  { iso: 'GQ', ddi: '240', name: 'Guiné Equatorial', flag: '🇬🇶' },
  { iso: 'GW', ddi: '245', name: 'Guiné-Bissau', flag: '🇬🇼' },
  { iso: 'HT', ddi: '509', name: 'Haiti', flag: '🇭🇹' },
  { iso: 'HN', ddi: '504', name: 'Honduras', flag: '🇭🇳' },
  { iso: 'HK', ddi: '852', name: 'Hong Kong, RAE da China', flag: '🇭🇰' },
  { iso: 'HU', ddi: '36', name: 'Hungria', flag: '🇭🇺' },
  { iso: 'YE', ddi: '967', name: 'Iêmen', flag: '🇾🇪' },
  { iso: 'CX', ddi: '61', name: 'Ilha Christmas', flag: '🇨🇽' },
  { iso: 'IM', ddi: '44', name: 'Ilha de Man', flag: '🇮🇲' },
  { iso: 'NF', ddi: '672', name: 'Ilha Norfolk', flag: '🇳🇫' },
  { iso: 'AX', ddi: '358', name: 'Ilhas Aland', flag: '🇦🇽' },
  { iso: 'CC', ddi: '61', name: 'Ilhas Cocos (Keeling)', flag: '🇨🇨' },
  { iso: 'CK', ddi: '682', name: 'Ilhas Cook', flag: '🇨🇰' },
  { iso: 'FO', ddi: '298', name: 'Ilhas Faroé', flag: '🇫🇴' },
  { iso: 'GS', ddi: '500', name: 'Ilhas Geórgia do Sul e Sandwich do Sul', flag: '🇬🇸' },
  { iso: 'FK', ddi: '500', name: 'Ilhas Malvinas', flag: '🇫🇰' },
  { iso: 'MP', ddi: '1670', name: 'Ilhas Marianas do Norte', flag: '🇲🇵' },
  { iso: 'MH', ddi: '692', name: 'Ilhas Marshall', flag: '🇲🇭' },
  { iso: 'PN', ddi: '872', name: 'Ilhas Pitcairn', flag: '🇵🇳' },
  { iso: 'SB', ddi: '677', name: 'Ilhas Salomão', flag: '🇸🇧' },
  { iso: 'TC', ddi: '1649', name: 'Ilhas Turcas e Caicos', flag: '🇹🇨' },
  { iso: 'VI', ddi: '1340', name: 'Ilhas Virgens Americanas', flag: '🇻🇮' },
  { iso: 'VG', ddi: '1284', name: 'Ilhas Virgens Britânicas', flag: '🇻🇬' },
  { iso: 'IN', ddi: '91', name: 'Índia', flag: '🇮🇳' },
  { iso: 'ID', ddi: '62', name: 'Indonésia', flag: '🇮🇩' },
  { iso: 'IR', ddi: '98', name: 'Irã', flag: '🇮🇷' },
  { iso: 'IQ', ddi: '964', name: 'Iraque', flag: '🇮🇶' },
  { iso: 'IE', ddi: '353', name: 'Irlanda', flag: '🇮🇪' },
  { iso: 'IS', ddi: '354', name: 'Islândia', flag: '🇮🇸' },
  { iso: 'IL', ddi: '972', name: 'Israel', flag: '🇮🇱' },
  { iso: 'IT', ddi: '39', name: 'Itália', flag: '🇮🇹' },
  { iso: 'JM', ddi: '1876', name: 'Jamaica', flag: '🇯🇲' },
  { iso: 'JP', ddi: '81', name: 'Japão', flag: '🇯🇵' },
  { iso: 'JE', ddi: '44', name: 'Jersey', flag: '🇯🇪' },
  { iso: 'JO', ddi: '962', name: 'Jordânia', flag: '🇯🇴' },
  { iso: 'KW', ddi: '965', name: 'Kuwait', flag: '🇰🇼' },
  { iso: 'LA', ddi: '856', name: 'Laos', flag: '🇱🇦' },
  { iso: 'LS', ddi: '266', name: 'Lesoto', flag: '🇱🇸' },
  { iso: 'LV', ddi: '371', name: 'Letônia', flag: '🇱🇻' },
  { iso: 'LB', ddi: '961', name: 'Líbano', flag: '🇱🇧' },
  { iso: 'LR', ddi: '231', name: 'Libéria', flag: '🇱🇷' },
  { iso: 'LY', ddi: '218', name: 'Líbia', flag: '🇱🇾' },
  { iso: 'LI', ddi: '423', name: 'Liechtenstein', flag: '🇱🇮' },
  { iso: 'LT', ddi: '370', name: 'Lituânia', flag: '🇱🇹' },
  { iso: 'LU', ddi: '352', name: 'Luxemburgo', flag: '🇱🇺' },
  { iso: 'MO', ddi: '853', name: 'Macau, RAE da China', flag: '🇲🇴' },
  { iso: 'MK', ddi: '389', name: 'Macedônia do Norte', flag: '🇲🇰' },
  { iso: 'MG', ddi: '261', name: 'Madagascar', flag: '🇲🇬' },
  { iso: 'MY', ddi: '60', name: 'Malásia', flag: '🇲🇾' },
  { iso: 'MW', ddi: '265', name: 'Malaui', flag: '🇲🇼' },
  { iso: 'MV', ddi: '960', name: 'Maldivas', flag: '🇲🇻' },
  { iso: 'ML', ddi: '223', name: 'Mali', flag: '🇲🇱' },
  { iso: 'MT', ddi: '356', name: 'Malta', flag: '🇲🇹' },
  { iso: 'MA', ddi: '212', name: 'Marrocos', flag: '🇲🇦' },
  { iso: 'MQ', ddi: '596', name: 'Martinica', flag: '🇲🇶' },
  { iso: 'MU', ddi: '230', name: 'Maurício', flag: '🇲🇺' },
  { iso: 'MR', ddi: '222', name: 'Mauritânia', flag: '🇲🇷' },
  { iso: 'YT', ddi: '262', name: 'Mayotte', flag: '🇾🇹' },
  { iso: 'MX', ddi: '52', name: 'México', flag: '🇲🇽' },
  { iso: 'MM', ddi: '95', name: 'Mianmar (Birmânia)', flag: '🇲🇲' },
  { iso: 'FM', ddi: '691', name: 'Micronésia', flag: '🇫🇲' },
  { iso: 'MZ', ddi: '258', name: 'Moçambique', flag: '🇲🇿' },
  { iso: 'MD', ddi: '373', name: 'Moldávia', flag: '🇲🇩' },
  { iso: 'MC', ddi: '377', name: 'Mônaco', flag: '🇲🇨' },
  { iso: 'MN', ddi: '976', name: 'Mongólia', flag: '🇲🇳' },
  { iso: 'ME', ddi: '382', name: 'Montenegro', flag: '🇲🇪' },
  { iso: 'MS', ddi: '1664', name: 'Montserrat', flag: '🇲🇸' },
  { iso: 'NA', ddi: '264', name: 'Namíbia', flag: '🇳🇦' },
  { iso: 'NR', ddi: '674', name: 'Nauru', flag: '🇳🇷' },
  { iso: 'NP', ddi: '977', name: 'Nepal', flag: '🇳🇵' },
  { iso: 'NI', ddi: '505', name: 'Nicarágua', flag: '🇳🇮' },
  { iso: 'NE', ddi: '227', name: 'Níger', flag: '🇳🇪' },
  { iso: 'NG', ddi: '234', name: 'Nigéria', flag: '🇳🇬' },
  { iso: 'NU', ddi: '683', name: 'Niue', flag: '🇳🇺' },
  { iso: 'NO', ddi: '47', name: 'Noruega', flag: '🇳🇴' },
  { iso: 'NC', ddi: '687', name: 'Nova Caledônia', flag: '🇳🇨' },
  { iso: 'NZ', ddi: '64', name: 'Nova Zelândia', flag: '🇳🇿' },
  { iso: 'OM', ddi: '968', name: 'Omã', flag: '🇴🇲' },
  { iso: 'NL', ddi: '31', name: 'Países Baixos', flag: '🇳🇱' },
  { iso: 'PW', ddi: '680', name: 'Palau', flag: '🇵🇼' },
  { iso: 'PA', ddi: '507', name: 'Panamá', flag: '🇵🇦' },
  { iso: 'PG', ddi: '675', name: 'Papua-Nova Guiné', flag: '🇵🇬' },
  { iso: 'PK', ddi: '92', name: 'Paquistão', flag: '🇵🇰' },
  { iso: 'PY', ddi: '595', name: 'Paraguai', flag: '🇵🇾' },
  { iso: 'PE', ddi: '51', name: 'Peru', flag: '🇵🇪' },
  { iso: 'PF', ddi: '689', name: 'Polinésia Francesa', flag: '🇵🇫' },
  { iso: 'PL', ddi: '48', name: 'Polônia', flag: '🇵🇱' },
  { iso: 'PR', ddi: '1939', name: 'Porto Rico', flag: '🇵🇷' },
  { iso: 'PT', ddi: '351', name: 'Portugal', flag: '🇵🇹' },
  { iso: 'KE', ddi: '254', name: 'Quênia', flag: '🇰🇪' },
  { iso: 'KG', ddi: '996', name: 'Quirguistão', flag: '🇰🇬' },
  { iso: 'KI', ddi: '686', name: 'Quiribati', flag: '🇰🇮' },
  { iso: 'GB', ddi: '44', name: 'Reino Unido', flag: '🇬🇧' },
  { iso: 'CF', ddi: '236', name: 'República Centro-Africana', flag: '🇨🇫' },
  { iso: 'CG', ddi: '242', name: 'República do Congo', flag: '🇨🇬' },
  { iso: 'DO', ddi: '1849', name: 'República Dominicana', flag: '🇩🇴' },
  { iso: 'RE', ddi: '262', name: 'Reunião', flag: '🇷🇪' },
  { iso: 'RO', ddi: '40', name: 'Romênia', flag: '🇷🇴' },
  { iso: 'RW', ddi: '250', name: 'Ruanda', flag: '🇷🇼' },
  { iso: 'RU', ddi: '7', name: 'Rússia', flag: '🇷🇺' },
  { iso: 'WS', ddi: '685', name: 'Samoa', flag: '🇼🇸' },
  { iso: 'AS', ddi: '1684', name: 'Samoa Americana', flag: '🇦🇸' },
  { iso: 'SM', ddi: '378', name: 'San Marino', flag: '🇸🇲' },
  { iso: 'SH', ddi: '290', name: 'Santa Helena', flag: '🇸🇭' },
  { iso: 'LC', ddi: '1758', name: 'Santa Lúcia', flag: '🇱🇨' },
  { iso: 'BL', ddi: '590', name: 'São Bartolomeu', flag: '🇧🇱' },
  { iso: 'KN', ddi: '1869', name: 'São Cristóvão e Névis', flag: '🇰🇳' },
  { iso: 'MF', ddi: '590', name: 'São Martinho', flag: '🇲🇫' },
  { iso: 'PM', ddi: '508', name: 'São Pedro e Miquelão', flag: '🇵🇲' },
  { iso: 'ST', ddi: '239', name: 'São Tomé e Príncipe', flag: '🇸🇹' },
  { iso: 'VC', ddi: '1784', name: 'São Vicente e Granadinas', flag: '🇻🇨' },
  { iso: 'SC', ddi: '248', name: 'Seicheles', flag: '🇸🇨' },
  { iso: 'SN', ddi: '221', name: 'Senegal', flag: '🇸🇳' },
  { iso: 'SL', ddi: '232', name: 'Serra Leoa', flag: '🇸🇱' },
  { iso: 'RS', ddi: '381', name: 'Sérvia', flag: '🇷🇸' },
  { iso: 'SG', ddi: '65', name: 'Singapura', flag: '🇸🇬' },
  { iso: 'SY', ddi: '963', name: 'Síria', flag: '🇸🇾' },
  { iso: 'SO', ddi: '252', name: 'Somália', flag: '🇸🇴' },
  { iso: 'LK', ddi: '94', name: 'Sri Lanka', flag: '🇱🇰' },
  { iso: 'SD', ddi: '249', name: 'Sudão', flag: '🇸🇩' },
  { iso: 'SS', ddi: '211', name: 'Sudão do Sul', flag: '🇸🇸' },
  { iso: 'SE', ddi: '46', name: 'Suécia', flag: '🇸🇪' },
  { iso: 'CH', ddi: '41', name: 'Suíça', flag: '🇨🇭' },
  { iso: 'SR', ddi: '597', name: 'Suriname', flag: '🇸🇷' },
  { iso: 'SJ', ddi: '47', name: 'Svalbard e Jan Mayen', flag: '🇸🇯' },
  { iso: 'TJ', ddi: '992', name: 'Tadjiquistão', flag: '🇹🇯' },
  { iso: 'TH', ddi: '66', name: 'Tailândia', flag: '🇹🇭' },
  { iso: 'TW', ddi: '886', name: 'Taiwan', flag: '🇹🇼' },
  { iso: 'TZ', ddi: '255', name: 'Tanzânia', flag: '🇹🇿' },
  { iso: 'CZ', ddi: '420', name: 'Tchéquia', flag: '🇨🇿' },
  { iso: 'IO', ddi: '246', name: 'Território Britânico do Oceano Índico', flag: '🇮🇴' },
  { iso: 'PS', ddi: '970', name: 'Territórios palestinos', flag: '🇵🇸' },
  { iso: 'TL', ddi: '670', name: 'Timor-Leste', flag: '🇹🇱' },
  { iso: 'TG', ddi: '228', name: 'Togo', flag: '🇹🇬' },
  { iso: 'TK', ddi: '690', name: 'Tokelau', flag: '🇹🇰' },
  { iso: 'TO', ddi: '676', name: 'Tonga', flag: '🇹🇴' },
  { iso: 'TT', ddi: '1868', name: 'Trinidad e Tobago', flag: '🇹🇹' },
  { iso: 'TN', ddi: '216', name: 'Tunísia', flag: '🇹🇳' },
  { iso: 'TM', ddi: '993', name: 'Turcomenistão', flag: '🇹🇲' },
  { iso: 'TR', ddi: '90', name: 'Turquia', flag: '🇹🇷' },
  { iso: 'TV', ddi: '688', name: 'Tuvalu', flag: '🇹🇻' },
  { iso: 'UA', ddi: '380', name: 'Ucrânia', flag: '🇺🇦' },
  { iso: 'UG', ddi: '256', name: 'Uganda', flag: '🇺🇬' },
  { iso: 'UY', ddi: '598', name: 'Uruguai', flag: '🇺🇾' },
  { iso: 'UZ', ddi: '998', name: 'Uzbequistão', flag: '🇺🇿' },
  { iso: 'VU', ddi: '678', name: 'Vanuatu', flag: '🇻🇺' },
  { iso: 'VE', ddi: '58', name: 'Venezuela', flag: '🇻🇪' },
  { iso: 'VN', ddi: '84', name: 'Vietnã', flag: '🇻🇳' },
  { iso: 'WF', ddi: '681', name: 'Wallis e Futuna', flag: '🇼🇫' },
  { iso: 'ZM', ddi: '260', name: 'Zâmbia', flag: '🇿🇲' },
  { iso: 'ZW', ddi: '263', name: 'Zimbábue', flag: '🇿🇼' },
];

/** Países oferecidos no topo da lista, por serem os mais comuns na base. */
export const PRIORITY_DDIS = ['55', '1', '351', '34', '39', '44', '49', '54'];

export const findCountryByDdi = (ddi) =>
  phoneCountries.find((c) => c.ddi === String(ddi || '')) || null;
